// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_yKW","cls2":"SingularMentionCitationModal-cls2_Iro SingularMentionCitationModal-cls1_yKW"};